module.exports = __webpack_public_path__ + "static/media/teresinha_de_fatima_nogueira.3e240cc9.jpg";